<template>
  <div>
    <div v-if="org">
      <div class="a-container-form contractor__block">
        <div class="a-label">{{$t('form.contractor.type-of-organization')}}:</div>
        <p class="a-input a-input--disabled" v-t="org.type.label"></p>
      </div>
      <div class="a-container-form contractor__block ">
        <div class="a-label ">{{$t('form.contractor.person-status')}}:</div>
        <p class="a-input a-input--disabled" v-t="'person-status.' + org.resident"></p>
      </div>
      <div class="a-container-form contractor__block">
        <div class="a-label ">{{$t('form.contractor.full-title')}}:</div>
        <p class="a-input a-input--disabled ">{{org.fullName}}</p>
      </div>
      <div class="a-container-form contractor__block" v-if="permissions.CAN_VIEW_ADMIN">
        <div class="a-label ">{{$t('form.contractor.short-title')}}:</div>
        <p class="a-input a-input--disabled ">{{org.shortName}}</p>
      </div>
      <div class="a-container-form contractor__block">
        <div class="a-label ">{{$t('labels.inn-long')}}:</div>
        <p class="a-input a-input--disabled ">{{org.inn}}</p>
      </div>
      <div class="a-container-form contractor__block" v-if="org.boss">
        <div class="a-label">{{$t('form.contractor.chief')}}:</div>
        <p class="a-input a-input--disabled ">{{org.boss | fullName}}</p>
      </div>
      <div class="a-container-form contractor__block" v-if="org.accountant">
        <div class="a-label">{{$t('form.contractor.chief-accountant')}}:</div>
        <p class="a-input a-input--disabled ">{{org.accountant | fullName}}</p>
      </div>
      <div class="a-container-form contractor__block" v-if="org.accountant">
        <div class="a-checkbox">
          <label class="a-checkbox__label">
            <input class="a-checkbox__input"
                   type="checkbox"
                   v-model="org.accountant.accountantOut"
                   disabled>
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text">
            Бухгалтерия на аутсорсинге
          </span>
          </label>
        </div>
      </div>
      <div class="personal-data__btn-block contractor__btn-block" v-if="permissions.CAN_EDIT_ORG || permissions.CAN_ADMIN_EDIT_ORG">
        <button class="gui-btn gui-btn--red gui-btn--w-140" v-t="'buttons.modify'" @click.prevent="$emit('modify')"></button>
      </div>
    </div>
    <div v-else>
      <button class="gui-btn gui-btn--red gui-btn--w-140" v-t="'buttons.create'" @click.prevent="$emit('modify')"></button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ContractorViewMode",

    computed: {
      org() {
        return this.$store.getters.currentOrganization;
      },
      permissions() {
        return this.$store.getters.currentUser.permissions;
      }
    }
  }
</script>

<style scoped>

</style>
